import introductionPage from '@app/content/data/introduction.json';
import researchPage from '@app/content/data/research.json';
import rulesPage from '@app/content/data/rules.json';

export const STATIC_PAGES: { [key: string]: any } = {
  'introduction': introductionPage,
  'research': researchPage,
  'rules': rulesPage,
};
